module.exports = __webpack_public_path__ + "static/media/image4.2c842e84.jpeg";